import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { adminQueries } from '@blimo/api-client';
import { useApi } from '@blimo/api-client/react';

/** "Lindenhof (1001)" @param {{ name?: string|null, number?: string|null, id?: number|string }} property */
export function propertyLabel(property) {
  return [property.name || `Liegenschaft #${property.id}`, property.number && `(${property.number})`].filter(Boolean).join(' ');
}

/**
 * Property options for filters and pickers from GET /admin/lookup/properties (all non-archived properties by name,
 * no page limit of the list endpoint).
 * @returns {{ options: Array<{ value: string, label: string }>, isPending: boolean }}
 */
export function usePropertyOptions() {
  const api = useApi();
  const query = useQuery(adminQueries.propertyLookup(api));
  const options = useMemo(() => (query.data ?? []).map((p) => ({ value: String(p.id), label: propertyLabel(p) })), [query.data]);
  return { options, isPending: query.isPending };
}
